import {
    URLAPI,
    MAINTENANCE_SUPPLIER_PATH,
    MAINTENANCE_SUPPLIER_CREATE_PATH,
    MAINTENANCE_SUPPLIER_UPDATE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_maintenance_supplier: {
        data: [],

        status: 0,
        message: {},
    },

    _create_maintenance_supplier: {
        data: {},
        status: 0,
        message: {},
    },
    _update_maintenance_supplier: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_MAINTENANCE_SUPPLIER = "GET_ALL_MAINTENANCE_SUPPLIER";
export const CREATE_MAINTENANCE_SUPPLIER = "CREATE_MAINTENANCE_SUPPLIER";
export const UPDATE_MAINTENANCE_SUPPLIER = "UPDATE_MAINTENANCE_SUPPLIER";

export const maintenance_supplier_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_MAINTENANCE_SUPPLIER:
            return {
                ...state,
                _get_all_maintenance_supplier: action.payload,
            };
        case CREATE_MAINTENANCE_SUPPLIER:
            return {
                ...state,
                _create_maintenance_supplier: action.payload,
            };
        case UPDATE_MAINTENANCE_SUPPLIER:
            return {
                ...state,
                _update_maintenance_supplier: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllMaintenanceSupplier = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${MAINTENANCE_SUPPLIER_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_MAINTENANCE_SUPPLIER,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_MAINTENANCE_SUPPLIER,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_MAINTENANCE_SUPPLIER,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createMaintenanceSupplier = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${MAINTENANCE_SUPPLIER_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_MAINTENANCE_SUPPLIER,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_MAINTENANCE_SUPPLIER,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_MAINTENANCE_SUPPLIER,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateMaintenanceSupplier = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${MAINTENANCE_SUPPLIER_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_MAINTENANCE_SUPPLIER,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_MAINTENANCE_SUPPLIER,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_MAINTENANCE_SUPPLIER,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_maintenance_supplier = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
